import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

export const budgetStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:budget.title`,
  subTitle: `quote:budget.subtitle`,
  additionalCopy: `quote:additionalCopy.description.title`,
  segmentEvent: `Additional Info Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.SELECT,
      summaryTitle: `quote:budget.summaryTitle`,
      props: {
        name: `budget`,
        options: [
          {
            label: `0 - 200€`,
            value: `0_200`,
          },
          {
            label: `200 - 500€`,
            value: `200_500`,
          },
          {
            label: `500 - 1000€`,
            value: `500_1000`,
          },
          {
            label: `1000 - 1500€`,
            value: `1000_1500`,
          },
          {
            label: `1500 - 2000€`,
            value: `1500_2000`,
          },
          {
            label: `2000 - 3000€`,
            value: `2000_3000`,
          },
          {
            label: `3000€ - 5000€`,
            value: `3000_5000`,
          },
          {
            label: `5000€ - 10 000€`,
            value: `5000_10000`,
          },
          {
            label: `10 000€ - 25 000€`,
            value: `10000_25000`,
          },
          {
            label: `> 30 000€`,
            value: `+30000`,
          },
        ],
        validation: [`isRequired`],
      },
    },
  ],
};
